import { RichText, RichTextValue } from "@/components/rich-text"

interface RichTextBlockProps {
  content: {
    content: RichTextValue
  }
}

export function RichTextBlock({ content }: RichTextBlockProps) {
  return (
    <div className="mx-auto mt-8 max-w-lg px-6">
      <RichText value={content.content} />
    </div>
  )
}
